export function toTitleCase(str: string | undefined) {
  return str
    ?.toLowerCase()
    ?.split(' ')
    ?.map((word) => (word.length > 1 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    ?.join(' ');
}
